import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN_LOCATION_FILE_PUBLIC = gql`
  query voohCampaignLocationsFilePublic($voohCampaignUuid: String) {
    voohCampaignLocationsFilePublic(voohCampaignUuid: $voohCampaignUuid) {
      url
    }
  }
`
